module.exports = __webpack_public_path__ + "static/media/icon-company.5db21a67.svg";